import React from "react";
import { Layout, Row, Col, Typography } from "antd";
const { Footer } = Layout;

const MainFooter = () => {
  return (
    <Footer
      style={{
        textAlign: "center",
      }}
    >
      <Row className="add-row">
        <Col span={24}>
          <Typography.Text className="footer-text">
            Webaku.az ©2023 Bütün Hüquqları Qorunur
          </Typography.Text>
        </Col>
      </Row>
    </Footer>
  );
};

export default MainFooter;
